<app-app-layout mainClass="main--tinted">
</app-app-layout>
